// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__tSSP-","content":"LoadingAlert_content__352RJ"};